/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import "./Nav.css";
import { Col, Container, Dropdown, Offcanvas, Row } from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { sidebarItems } from "./SidebarData";
import DeleteModel from "../../../components/DeleteModel";
import logo from "../../../assets/images/logo.jpg";
import { Menu } from "antd";
import { clearAllLocalStorage } from "../../../constants/localStorage";
import { app_Name } from "../../../constants/helpers";
import { BoxArrowRight, PersonCircle } from "react-bootstrap-icons";
import { colors } from "../../../constants/theme";
import { useGetMeQuery } from "../../../redux/api/Admin/AuthApi";

const { SubMenu } = Menu;

const MainNav = () => {
  const { color } = "#ffffff";
  const [show, setShow] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  // Use the getMe hook to fetch current user data
  const { data: userData, isLoading, isError } = useGetMeQuery();
  const currentUser = userData?.data?.user;

  const handleClose = () => setShow(false);
  const handleNavigateAddForm = () => setShow(true);
  const handleModelClose = () => setLogoutShow(false);

  const handleLogout = () => {
    clearAllLocalStorage();
    navigate("/adminlogin");
    window.location.reload();
  };

  const findSelectedKey = (items, path) => {
    for (const item of items) {
      if (item.url === path) {
        return item.id.toString();
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children, path);
        if (childKey) {
          return childKey;
        }
      }
    }
    return null;
  };

  const selectedKey = findSelectedKey(sidebarItems, location.pathname);

  useEffect(() => {
    const findParentKey = (items, path) => {
      for (const item of items) {
        if (item.url === path) {
          return item.id.toString();
        }
        if (item.children) {
          const childKey = findParentKey(item.children, path);
          if (childKey) {
            return item.id.toString();
          }
        }
      }
      return null;
    };

    const parentKey = findParentKey(sidebarItems, location.pathname);
    if (parentKey) {
      setOpenKeys([parentKey]);
    }
  }, [location.pathname]);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const filteredSidebarItems = React.useMemo(() => {
    if (!currentUser) return [];

    return sidebarItems.filter((item) => item.roles.includes(currentUser.role));
  }, [currentUser]);

  // Handle loading and error states
  if (isLoading) {
    return (
      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60px" }}
      >
        <div>Loading...</div>
      </Container>
    );
  }

  if (isError || !currentUser) {
    return (
      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60px" }}
      >
        <div>Error loading user data</div>
      </Container>
    );
  }

  return (
    <>
      <Container
        fluid
        className="d-flex flex-row flex-wrap-wrap justify-content-between align-items-center overflowX-hidden"
        style={{
          position: "sticky",
          top: "0",
          zIndex: 1000,
          backgroundColor: "#ffffff",
          borderBottom: "2px solid #e9edf4",
        }}
      >
        <Row className="d-flex flex-row flex-wrap-wrap justify-content-around align-items-center p-2">
          <Col className="d-lg-none d-xl-none d-sm-flex">
            <AiOutlineMenu
              size={25}
              onClick={handleNavigateAddForm}
              className="pointer"
              color="#515b73"
            />
          </Col>
          <Col
            className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-between align-items-center"
            style={{ marginRight: "100px" }}
          >
            <img
              src={logo}
              width={45}
              className="pointer"
              alt="MainLogoImage1"
              title="MainLogoImage1"
            />
          </Col>
        </Row>

        {/* mobile view */}
        <Row>
          <Col className='d-lg-none d-sm-flex flex-row flex-wrap-wrap justify-content-between" align-items-center'>
            <img
              src={logo}
              width={50}
              className="p-2 pointer rounded-circle"
              alt="MainLogoImage2"
              title="MainLogoImage2"
            />
          </Col>
        </Row>

        <Row className="d-flex mt-1">
          {/* lap view */}
          <Col className="d-flex flex-row flex-wrap-wrap justify-content-center align-items-center position-relative">
            <div className="d-flex align-items-center position-relative">
              <Dropdown align="end">
                <Dropdown.Toggle
                  id="user-dropdown"
                  variant="light"
                  className="bg-transparent border-0 p-1"
                >
                  {currentUser.avatar ? (
                    <img
                      src={currentUser.avatar}
                      alt="User Avatar"
                      width={32}
                      height={32}
                      className="rounded-circle"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <PersonCircle size={32} color={colors.primaryColor} />
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="shadow-sm"
                  style={{ minWidth: "250px" }}
                >
                  {/* User Info Section */}
                  <div className="px-4 py-3 border-bottom">
                    <div className="d-flex align-items-center mb-2">
                      {currentUser.avatar ? (
                        <img
                          src={currentUser.avatar}
                          alt="User Avatar"
                          width={36}
                          height={36}
                          className="rounded-circle me-2"
                          style={{ objectFit: "cover" }}
                        />
                      ) : (
                        <PersonCircle size={36} className="text-primary me-2" />
                      )}
                      <div>
                        <div className="fw-bold">{currentUser.name}</div>
                        <small className="text-muted text-capitalize">
                          {currentUser.role}
                        </small>
                      </div>
                    </div>
                    <small className="text-muted d-block text-truncate">
                      {currentUser.email}
                    </small>
                    {currentUser.lastLoginAt && (
                      <small className="text-muted d-block mt-1">
                        Last login:{" "}
                        {new Date(currentUser.lastLoginAt).toLocaleDateString()}
                      </small>
                    )}
                  </div>

                  <Dropdown.Item
                    className="d-flex align-items-center py-2 text-danger"
                    onClick={() => setLogoutShow(true)}
                  >
                    <BoxArrowRight size={16} className="me-2" />
                    <span>Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Conditionally render Offcanvas for large screens */}
      <Row className="d-none d-lg-flex">
        <Offcanvas scroll={false} show={show} onHide={handleClose}>
          <Offcanvas.Header style={{ backgroundColor: color }} closeButton>
            <Offcanvas.Title
              className="custom-title"
              style={{
                fontSize: "16px",
                color: "#515b73",
              }}
            >
              <img
                src={logo}
                width={50}
                className="rounded-circle p-2"
                alt="image"
              />
              <span className="fw-bolder" style={{ fontSize: "12px" }}>
                {app_Name}
              </span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ backgroundColor: " #FFFFFF" }}>
            <Menu
              mode="inline"
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              selectedKeys={[selectedKey]}
              style={{ height: "100%", borderRight: 0 }}
              theme="light"
            >
              {filteredSidebarItems.map((menu) =>
                menu.children && menu.children.length > 0 ? (
                  <SubMenu
                    key={menu.id}
                    icon={menu.icon}
                    style={{
                      color:
                        selectedKey === menu.id.toString() ||
                        menu.children.some(
                          (child) => selectedKey === child.id.toString()
                        )
                          ? "var(--primary-color)"
                          : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id.toString() ||
                        menu.children.some(
                          (child) => selectedKey === child.id.toString()
                        )
                          ? "#E5D6F3"
                          : "#ffffff",
                    }}
                    title={
                      <span style={{ color: "#6d758a" }}>{menu.label}</span>
                    }
                  >
                    {menu.children.map((item) => (
                      <Menu.Item
                        key={item.id}
                        icon={item.icon}
                        style={{
                          color:
                            selectedKey === item.id.toString()
                              ? "var(--primary-color)"
                              : "#6d758a",
                          backgroundColor:
                            selectedKey === item.id.toString()
                              ? "#E5D6F3"
                              : "#ffffff",
                        }}
                      >
                        <Link
                          className="link-unstyled"
                          onClick={handleClose}
                          to={item.url}
                        >
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item
                    key={menu.id}
                    icon={menu.icon}
                    style={{
                      color:
                        selectedKey === menu.id.toString()
                          ? "var(--primary-color)"
                          : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id.toString()
                          ? "#e0dee2"
                          : "#ffffff",
                      fontWeight:
                        selectedKey === menu.id.toString() ? "600" : "",
                    }}
                  >
                    <Link
                      className="link-unstyled"
                      onClick={handleClose}
                      to={menu.url}
                    >
                      {menu.label}
                    </Link>
                  </Menu.Item>
                )
              )}
            </Menu>
          </Offcanvas.Body>
        </Offcanvas>
      </Row>

      <DeleteModel
        DELETESTATE={logoutShow}
        ONCLICK={handleModelClose}
        YES={handleLogout}
        DESCRIPTION="Do You Want To Logout"
        DELETETITLE="Logout"
      />
    </>
  );
};

export default MainNav;
